import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

const UserTracker = ({ user }) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [phone, setPhone] = useState("");
  const [trackingId, setTrackingId] = useState(null);  

  useEffect(() => {
    // Assign tracking ID
    let currentTrackingId;
    
    if (user?.id) {
      currentTrackingId = user.id;
      setTrackingId(user.id);
      Cookies.set("userType", "loggedIn", { expires: 30, secure: true, sameSite: "Strict" });
      Cookies.set("trackingId", user.id, { expires: 30, secure: true, sameSite: "Strict" });
    } else {
      const guestId = Cookies.get("guestId") || `guest_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
      currentTrackingId = guestId;
      setTrackingId(guestId);
      Cookies.set("guestId", guestId, { expires: 7, secure: true, sameSite: "Strict" });
      Cookies.set("userType", "guest", { expires: 7, secure: true, sameSite: "Strict" });
    }

    // Track page view
    fetch(`${API_URL}/tracking`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        trackingId: currentTrackingId,
        userType: user?.id ? "loggedIn" : "guest",
        viewedPage: location.pathname,
        timestamp: new Date().toISOString(),
      }),
    }).catch((err) => console.error("Tracking error:", err));

    // Show phone modal on page close for guests
    if (!user?.id && !Cookies.get("phoneCollected")) {
      const handleBeforeUnload = (e) => {
        // Trigger browser's native dialog to prevent immediate leave
        e.preventDefault();
        e.returnValue = "Please provide your phone number before leaving.";
        // Show modal (may not render until user cancels dialog)
        setShowPhoneModal(true);
      };

      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [location.pathname, user, API_URL]);

  // Submit phone number
  const handlePhoneSubmit = () => {
    const phoneRegex = /^[0-9]{10,}$/;
    if (!phoneRegex.test(phone)) {
      alert("❌ Please enter a valid phone number (at least 10 digits).");
      return;
    }

    fetch(`${API_URL}/tracking`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        trackingId,
        userType: "guest",
        viewedPage: "exit-intent",
        phoneNumber: phone,
        timestamp: new Date().toISOString(),
      }),
    })
      .then((response) => {
        if (response.ok) {
          Cookies.set("phoneCollected", "true", { expires: 7, secure: true, sameSite: "Strict" });
          setShowPhoneModal(false);
          setPhone("");
        } else {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      })
      .catch((err) => console.error("Phone tracking error:", err));
  };

  // Close modal without submitting
  const handleCloseModal = () => {
    setShowPhoneModal(false);
    setPhone("");
  };

  return (
    <>
      {showPhoneModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "10px",
              textAlign: "center",
              width: "300px",
            }}
          >
            <h3>📢 Wait! Before you go...</h3>
            <p>Enter your phone number so we can follow up:</p>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Phone number"
              style={{
                width: "100%",
                padding: "8px",
                marginBottom: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            />
            <div>
              <button
                onClick={handlePhoneSubmit}
                style={{
                  background: "#ff6600",
                  color: "#fff",
                  padding: "8px 15px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              >
                Submit
              </button>
              <button
                onClick={handleCloseModal}
                style={{
                  background: "#ccc",
                  color: "#000",
                  padding: "8px 15px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserTracker;